export const LOAD_REQUESTED = "TOP_LEVEL_ARRAY_FIELD_TEMPLATE/LOAD_REQUESTED";
export const LOAD_SUCCESS = "TOP_LEVEL_ARRAY_FIELD_TEMPLATE/LOAD_SUCCESS";
export const LOAD_FAIL = "TOP_LEVEL_ARRAY_FIELD_TEMPLATE/LOAD_FAIL";

export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadTopLevelArrayFieldTemplate = data => ({ type: LOAD_REQUESTED, data });
export const successLoadTopLevelArrayFieldTemplate = data => ({ type: LOAD_SUCCESS, data });
export const failLoadTopLevelArrayFieldTemplate = data => ({ type: LOAD_FAIL, data });
